import { Card, Stack, Row, Col } from "react-bootstrap";
import {
  CardTitle,
  CardDataLabel,
  CardDataValue,
} from "../components/card_components";
import TableCellChip from "@/components/Table/cell_formats/TableCellChip";
import TableCellCurrency from "@/components/Table/cell_formats/TableCellCurrency";
import TableCellDate from "@/components/Table/cell_formats/TableCellDate";

export default function LoanCard({ loanSummary }) {
  return (
    <Card className="border-0 rounded-lg">
      <Card.Body>
        <Stack gap={2}>
          <Card.Title>
            <Stack direction="horizontal">
              <CardTitle title={"Loan Information"} csx={"me-auto"} />
              <TableCellChip value={loanSummary?.status || "—"} />
            </Stack>
          </Card.Title>

          <Stack gap={3}>
            <Row className="g-3">
              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Loan ID"} />
                  <CardDataValue
                    title={loanSummary?.loanAccountNumber || "—"}
                  />
                </Stack>
              </Col>

              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Business Name"} />
                  <CardDataValue title={loanSummary?.customerName} />
                </Stack>
              </Col>

              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Cust Id"} />
                  <CardDataValue title={loanSummary?.customerUrn || "—"} />
                </Stack>
              </Col>

              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Loan Type"} />
                  <CardDataValue title={"Revenue Based Financing"} />
                </Stack>
              </Col>
            </Row>
          </Stack>

          <hr className="my-2 border-primary-light" />

          <Stack gap={3}>
            <Row className="g-3">
              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Original Amount"} />
                  <TableCellCurrency
                    value={loanSummary?.disbursedAmount || 0}
                  />
                </Stack>
              </Col>

              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Total Outstanding Amount"} />
                  <TableCellCurrency
                    value={loanSummary?.totalOutstanding || 0}
                  />
                </Stack>
              </Col>

              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Disbursement Date"} />
                  <TableCellDate
                    value={loanSummary?.firstDisbursmentDate}
                    options={{ formatType: "long" }}
                  />
                </Stack>
              </Col>

              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Maturity Date"} />
                  <TableCellDate
                    value={loanSummary?.maturityDate}
                    options={{ formatType: "long" }}
                  />
                </Stack>
              </Col>

              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Tenure"} />
                  <CardDataValue
                    title={
                      loanSummary?.originalTenor
                        ? `${loanSummary.originalTenor} Months`
                        : "—"
                    }
                  />
                </Stack>
              </Col>

              <Col xs={12} sm={6}>
                <Stack>
                  <CardDataLabel title={"Int_Fee Rate"} />
                  <CardDataValue
                    title={
                      loanSummary?.interestRate
                        ? `${loanSummary.interestRate}%`
                        : "—"
                    }
                  />
                </Stack>
              </Col>
            </Row>
          </Stack>

        </Stack>
      </Card.Body>
    </Card>
  );
}
